/* eslint-disable jsx-a11y/click-events-have-key-events */

import { Grid, InputLabel } from '@material-ui/core'
import { Help } from '@material-ui/icons'
/* eslint-disable jsx-a11y/no-static-element-interactions */
import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import Tooltip from '../Tooltip'

const LabelWrapper = ({
  actionLink,
  actionLinkTestId,
  bigLabel,
  center,
  checkboxes,
  children,
  className,
  customCol,
  customMargin,
  customPadding,
  customWidth,
  disabled,
  disableIconClick,
  errorText,
  fullWidth,
  hasError,
  helperText,
  id,
  inputClassName,
  isLabelInline,
  isRequired,
  isToolTip,
  isFilter,
  justify,
  label,
  labelIcon,
  multipleDirection,
  multipleFields,
  multipleNoWrap,
  noMobile,
  noSpacing,
  notWrapper,
  noWrap,
  onClick,
  onClickActionLink,
  onMouseEnter,
  onMouseLeave,
  setTooltipDangerously,
  showActionLink,
  spacing,
  subField,
  toolTipIcon,
  toolTipPosition,
  toolTipText,
  willDelete,
  withBorder,
  withDivider,
  ...rest
}) => {
  return (
    <ThemeProvider theme={theme}>
      <InputFieldWrapper
        className={cn(
          {
            'without-label': !label,
            withDivider,
            withBorder,
            noSpacing,
            plain: !withDivider && !withBorder,
          },
          'label-wrapper',
          className
        )}
        style={{
          margin: customMargin,
          padding: customPadding,
        }}
        multipleNoWrap
        {...rest}
      >
        <div
          className={cn(
            {
              'filter-content-wrapper': isFilter,
            },
            'content-wrapper'
          )}
        >
          <Grid
            container
            spacing={spacing}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            role="presentation"
            onClick={onClick}
            className={cn(
              {
                bordered: withBorder,
                'label-inline': isLabelInline,
                'disabled-icon': disableIconClick,
                'full-width': fullWidth,
                'has-error': errorText || hasError,
                'input-field': notWrapper,
                deleting: willDelete,
                'custom-width': customWidth,
                'no-wrap': noWrap,
                noSpacing,
                disabled,
              },
              'wrapped'
            )}
            direction={!isLabelInline ? 'column' : 'row'}
            justify={justify}
          >
            {label && (
              <Grid
                className={cn('field-label', { 'field-label-col': isLabelInline })}
                item
                lg={isLabelInline && !subField && 2}
                md={isLabelInline && !subField && 3}
                sm={isLabelInline && !subField && 4}
                xs={noMobile ? 3 : 12}
              >
                <InputLabel className={cn({ bigLabel }, 'label')} htmlFor={id}>
                  {isRequired ? <span className="required">{label}</span> : label}
                  {labelIcon}{' '}
                  {isToolTip && (
                    <Tooltip
                      content={toolTipText}
                      placement={toolTipPosition}
                      setTooltipDangerously={setTooltipDangerously}
                      disableTouchListener
                    >
                      {toolTipIcon}
                    </Tooltip>
                  )}
                </InputLabel>
                {showActionLink && !isLabelInline && (
                  // biome-ignore lint/a11y/noStaticElementInteractions: TODO
                  // biome-ignore lint/a11y/useKeyWithClickEvents: TODO
                  <span className="actionLink" onClick={onClickActionLink} data-testid={actionLinkTestId}>
                    {actionLink}
                  </span>
                )}
                {isLabelInline && helperText && <div className="helper-text">{helperText}</div>}
              </Grid>
            )}
            {/** biome-ignore lint/complexity/noUselessFragments: TODO */}
            <>
              {customWidth ? (
                <span style={customWidth && { width: customWidth }}>{children}</span>
              ) : (
                <Grid
                  item
                  lg={isLabelInline && label ? customCol || 10 : 12}
                  md={isLabelInline && label ? customCol || 9 : 12}
                  sm={isLabelInline && label ? customCol || 8 : 12}
                  xs={noMobile ? customCol : 12}
                  className={cn(
                    {
                      'no-label': !label,
                      center,
                      checkboxes,
                      multipleFields,
                    },
                    multipleDirection,
                    inputClassName,
                    'field-col'
                  )}
                >
                  {children}
                </Grid>
              )}
            </>
          </Grid>
          <Grid container spacing={spacing} justify={justify}>
            {withBorder && isLabelInline ? (
              <Grid
                lg={isLabelInline && !subField && 2}
                md={isLabelInline && !subField && 3}
                sm={isLabelInline && !subField && 4}
                xs={noMobile ? 3 : 12}
                className={cn('field-label-col')}
              />
            ) : null}
            <Grid
              item
              lg={isLabelInline && label ? customCol || 10 : 12}
              md={isLabelInline && label ? customCol || 9 : 12}
              sm={isLabelInline && label ? customCol || 8 : 12}
              xs={noMobile ? customCol : 12}
              className={cn('extra-items', 'field-col')}
            >
              {errorText && errorText !== ' ' && (
                <div className="error-text" style={customWidth && { width: `${customWidth}px` }}>
                  {errorText}
                </div>
              )}
              {!isLabelInline && helperText && <div className="helper-text helper-text-nil">{helperText}</div>}
            </Grid>
          </Grid>
        </div>
        {withDivider && <div className="divider" />}
      </InputFieldWrapper>
    </ThemeProvider>
  )
}

LabelWrapper.defaultProps = {
  actionLink: '',
  bigLabel: false,
  center: false,
  checkboxes: false,
  disabled: false,
  disableIconClick: false,
  errorText: '',
  fullWidth: true,
  helperText: '',
  id: '',
  isLabelInline: false,
  isRequired: false,
  isToolTip: false,
  justify: 'flex-start',
  label: '',
  labelIcon: null,
  multipleDirection: 'row',
  multipleFields: false,
  multipleNoWrap: false,
  noMobile: false,
  noSpacing: false,
  notWrapper: false,
  noWrap: false,
  onClick: () => {},
  onClickActionLink: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  setTooltipDangerously: false,
  showActionLink: false,
  spacing: 0,
  toolTipIcon: <Help className="toolTipIcon" />,
  toolTipIconColor: '',
  toolTipIconSize: 16,
  toolTipPosition: 'top',
  toolTipText: '',
  willDelete: false,
  withBorder: false,
  withDivider: false,
}

const InputFieldWrapper = styled.div`
  &.without-label {
    &.toggle-group {
      display: block;
    }
  }
  .label {
    width: 100%;
    margin: 0;
    font-size: ${props => props.theme.typography.fontSizeTinyish};
    word-wrap: break-word;
    text-align: left;
    display: flex;
    align-items: center;
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    line-height: normal;
    padding: 0 18px 0 0;
    .required::after {
      content: ' *';
      color: ${props => props.theme.status.errorColor};
    }
    &.bigLabel {
      font-size: ${props => props.theme.typography.fontSizeMedish};
      color: var(--gameday-body-headingColor, ${theme.body.headingColor});
      font-weight: ${props => props.theme.typography.fontWeightBolder};
    }
    & > span {
      line-height: normal;
    }
  }

  .label-error {
    padding-top: 1.25rem;
    font-weight: ${props => props.theme.typography.fontWeightNormal};
    font-size: ${props => props.theme.typography.fontSizeSm};
    word-wrap: break-word;
    color: ${props => props.theme.status.errorColor};
  }

  .prefix,
  .suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    background-color: ${props => props.theme.colors.offWhite};
    height: 100%;
    svg {
      font-size: 20px;
    }
  }

  .prefix {
    border-radius: 4px 0 0 4px;
    border-right: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
  }

  .suffix {
    border-radius: 0 4px 4px 0;
    border-left: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
  }

  .disabled {
    &.bordered {
      .prefix {
        background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
        border-color: ${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`};
        color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
        opacity: ${props => props.theme.inputField.inputDisabledOpacity};
      }
    }
    .prefix {
      border: none;
      &:hover {
        cursor: not-allowed;
      }
    }
  }

  &:not(.withBorder) {
    .prefix {
      border: none;
    }
  }

  input {
    height: 36px;
    box-sizing: border-box;
    color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
    font-size: ${props => props.theme.typography.fontSizeSm};
    &:focus {
      color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
    }
    &::placeholder {
      color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
      opacity: 0.7;
      font-weight: ${props => props.theme.typography.fontWeightNormal};
    }
    &:not(:disabled):hover::placeholder {
      color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
      opacity: 1;
    }
    &:disabled {
      color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
    }
    &:disabled:hover {
      cursor: not-allowed;
    }
  }

  textarea {
    &:not(:disabled):hover::placeholder {
      color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
      opacity: 1;
    }
  }

  .error-text {
    color: ${props => props.theme.status.errorColor};
    font-weight: ${props => props.theme.typography.fontWeightNormal};
    font-size: ${props => props.theme.typography.fontSizeSmaller};
    font-style: normal;
    margin-top: 6px;
  }

  .divider {
    display: block;
    margin: 0 0 12px;
    border-bottom: 1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};
  }

  .custom-textfield {
    height: 2.25rem;
    @media (max-width: 599px) {
      width: 100%;
    }
    &.willDelete,
    &.willDelete input::placeholder {
      opacity: 0.6;
      text-decoration: line-through;
    }
  }

  .custom-textfield > div {
    height: 2.125rem;
  }

  .custom-textfield .input-icon {
    padding: 0.3125rem;
    width: auto;
    height: auto;
    position: absolute;
    right: 5px;
  }

  .custom-textfield > div::before,
  .custom-textfield > div:hover::before,
  .custom-textfield > div::after {
    border-bottom: none !important;
  }

  .click-field input:disabled {
    color: #000;
    -webkit-text-fill-color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
    opacity: 1;
    &:hover {
      cursor: pointer;
    }
  }

  .label-inline {
    align-items: flex-start;
  }

  .label-inline .label {
    min-height: 36px;
  }

  .wrapped:not(.disabled-icon) .input-icon:hover {
    color: ${props => props.theme.inputField.inputBorderActive};
    background: transparent;
  }

  .field-label {
    justify-content: space-between;
    display: flex;
    align-items: ${props => (props.isLabelInline ? 'center' : 'unset')};
  }

  .field-label-col {
    flex-direction: column;
  }

  .wrapped:not(.label-inline) .field-label {
    padding: 2px 0;
  }

  .bordered {
    .custom-textfield {
      background-color: ${`var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`};
      border: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
      border-radius: 4px;
      transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
      &:focus-within {
        border-color: ${props => props.theme.inputField.inputBorderActive};
      }
      input {
        padding: 0 0 0 0.625rem;
        height: 34px;
        border-radius: 4px;
      }
    }
    &.disabled .custom-textfield {
      background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
      border-color: ${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`};
      color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
      opacity: ${props => props.theme.inputField.inputDisabledOpacity};
    }
    &.has-error .custom-textfield:not(.disabled),
    &.has-error .SingleDatePickerInput__withBorder {
      border-color: ${props => props.theme.status.errorColor};
      .MuiSvgIcon-root {
        background-color: transparent !important;
      }
    }
    &.has-error .prefix,
    &.has-error .suffix {
      border-color: ${props => props.theme.status.errorBorder};
      color: ${props => props.theme.status.errorBorder};
    }
  }

  .input-field:not(.bordered) {
    border-bottom: 1px solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};
    transition: border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    input {
      padding: 6px 10px;
    }
    .custom-textfield {
      padding-right: 0;
    }
    &:focus-within {
      border-color: ${props => props.theme.inputField.inputBorderActive};
      .custom-textfield input {
        background-color: ${`var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`};
      }
    }
    &.label-inline .custom-textfield {
      &:hover input {
        background-color: ${`var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor})`};
      }
    }
    &.has-error {
      border-color: ${props => props.theme.status.errorBorder};
    }
  }

  .wrapped:not(.full-width):not(.label-inline) {
    display: inline-block;
    width: auto;
  }

  .actionLink {
    color: ${props => props.theme.palette.primary.main};
    font-size: 12px;
    float: right;
    cursor: pointer;
    font-weight: ${props => props.theme.typography.fontWeightBolder};
  }

  .actionLinkInline {
    color: ${props => props.theme.palette.primary.main};
    font-size: ${props => props.theme.typography.fontSizeSmaller};
    float: right;
    padding-top: 8px;
  }

  .toolTipIcon {
    font-size: ${props => props.toolTipIconSize}px;
    margin-left: 6px;
    color: ${props => props.toolTipIconColor || props.theme.body.textColorAlt};
    vertical-align: sub;
  }

  .has-children {
    display: flex;
    align-items: center;
    font-size: ${props => props.theme.typography.fontSizeSm};
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    min-height: 36px;
  }

  .helper-text {
    width: 100%;
    font-size: ${props => props.theme.typography.fontSizeSm};
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    padding: 0 18px 0 0;
  }

  .full-width .SingleDatePickerInput,
  .full-width .SingleDatePicker,
  .full-width .SingleDatePicker .DateInput,
  .full-width .DateRangePickerInput,
  .full-width .DateRangePicker,
  .full-width .DateRangePicker .DateInput {
    width: 100%;
  }

  .checkboxes {
    display: flex;
    flex-wrap: wrap;
    > span {
      width: 160px;
      label > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      label > span {
        width: 42px;
        height: 42px;
      }
    }
  }

  .label-wrapper,
  &.plain {
    margin-bottom: 0;
  }

  .multipleFields {
    display: flex;
    flex-wrap: ${props => (props.multipleNoWrap ? 'nowrap' : 'wrap')};
    > *:not(:last-child) {
      margin-right: 16px;
    }
    > * {
      margin-bottom: 0;
    }
    .label-wrapper > :not(.label-inline) .field-label {
      padding: 0px;
    }
    .no-label {
      padding: 0 !important;
    }
    &.row {
      flex-direction: row;
    }
    &.column {
      flex-direction: column;
      > *:not(:last-child) {
        margin-right: 0px;
      }
    }
    .label-inline {
      flex-wrap: nowrap;
    }
    .custom-width.no-wrap label {
      margin-right: 16px;
    }
  }

  .center {
    align-self: center;
  }

  &.date-picker .disabled {
    .SingleDatePickerInput__disabled {
      background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
      border-color: ${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`};
      color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
      opacity: ${props => props.theme.inputField.inputDisabledOpacity};
    }
    .no-label {
      padding: 0 !important;
    }
    .DateInput_input__disabled,
    .DateInput__disabled {
      background: transparent !important;
      font-style: normal;
    }
    button {
      opacity: 0;
      &:hover {
        cursor: not-allowed;
      }
    }
  }

  &.date-picker.withBorder .DateInput input {
    padding-left: 0.625rem;
  }

  &.withBorder.date-picker .wrapped {
    border-bottom: 0px;
  }

  &.without-label .error-text {
    margin: 6px 0;
  }

  & .has-error textarea {
    border-color: ${props => props.theme.status.errorColor};
    background-color: ${props => props.theme.status.errorBG};
  }

  & .disabled .multi-select-input {
    background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    border-color: ${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`};
    color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
    opacity: ${props => props.theme.inputField.inputDisabledOpacity};
  }

  & .has-error .multi-select-input {
    border-color: ${props => props.theme.status.errorColor};
  }

  & .disabled .multi-select .drop-icon {
    color: var(--gameday-body-textColor, ${theme.body.textColor});
  }

  & .disabled .multi-select-input:hover {
    cursor: not-allowed;
  }

  &.withDivider .extra-items:empty {
    padding: 0;
  }

  &.input-textarea:not(.withDivider) .wrapped {
    padding: 8px 0;
  }

  &.plain {
    padding: 1px 0;
  }

  & .no-wrap label {
    white-space: nowrap;
  }

  .no-wrap {
    flex-wrap: nowrap !important;
  }

  &.withBorder:not(.noSpacing) .content-wrapper {
    padding-bottom: 16px;
  }

  &.withBorder:not(.noSpacing) .filter-content-wrapper {
    padding-bottom: 0;
  }
`

export default LabelWrapper
